import { urlForImage } from '@/Constants/common';

export function getImageHandler(src) {
    if (![ '', null, 'null', undefined, 'undefined' ].includes(src)) {
        return getImage(src);
    }
    return './demo/UI/noImg.png';
}

export function getImage(src) {
    return src;
}

export function getStaticImage(src) {
    if (![ '', null, 'null', undefined, 'undefined' ].includes(src)) {
        return src;
    }
    return './demo/UI/noImg.png';
}
